import Axios from "axios";

export default function AdminPanelLogin(email,password){    
    let response = Axios.get(process.env.REACT_APP_GATEWAY_URL, {
        params: {
            a: 'adminLogin',
            email, password
        }
    });
    return response;
}